<footer>
  <div class="container-fluid-lg pt-5 ms-5 me-5 ">
    <div class="row">
      <div class="d-none d-lg-block logo_container col-md-6 mt-md-5">
        <img src="assets/imgs/Bhavani_blanco.png" alt="Logo alternativo 1" i18n-alt srcset="">
      </div>
      <div class="bg-transparent accordion accordion-flush col-md mt-md-4 d-md-flex justify-content-between"
        id="accordionFooter">
        <div *ngFor="let element of footer_links; let i =index;" class="accordion-item bg-transparent ">
          <h2 class="accordion-header" attr.id="flush-heading-{{i}}">
            <button class="accordion-button collapsed bg-transparent " type="button" data-bs-toggle="collapse"
              attr.data-bs-target="#flush-collapse-{{i}}" aria-expanded="false"
              attr.aria-controls="flush-collapse-{{i}}">
              <strong>{{element.top_link_name}}</strong>
            </button>
          </h2>
          <div attr.id="flush-collapse-{{i}}" class="accordion-collapse collapse"
            attr.aria-labelledby="flush-heading-{{i}}" data-bs-parent="#accordionFooter">
            <div class="accordion-body">
              <ul class="text-start pt-3 ps-0">
                <li class="mb-3" *ngFor="let sub_element of element.sub_links">
                  <a *ngIf="!sub_element.external" routerLink="{{sub_element.path}}"
                    [fragment]="sub_element.fragment ? sub_element.fragment : undefined ">{{sub_element.name}}</a>
                  <a *ngIf="sub_element.external" [href]="sub_element.path">{{sub_element.name}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer_logo text-center p-2">
    <img src="assets/imgs/svgs/footer_logo.svg" alt="Logo pie de página" i18n-alt loading="lazy">
    <p class="mt-5"><a [href]="this.changeLanLink">{{this.changeLanText}}</a></p>
    <p class="mt-3" i18n>Copyright © Bhavani. Todos los derechos reservados.</p>
  </div>
</footer>